<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> PRODUTO </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="product.id"
          >{{ code }} - {{ product.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-chip
          v-if="product.sample_product == 1"
          class="ma-2"
          label
          color="brown"
          text-color="white"
        >
          <v-icon left> mdi-tag </v-icon>
          Amostra
        </v-chip>
        <v-chip class="ma-2" label color="green" text-color="white">
          <v-icon left> mdi-label </v-icon>
          {{ getLabelReissue() }}
        </v-chip>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-alert border="bottom" color="pink darken-1" dark v-if="error">
          <v-row align="center">
            <v-col class="grow">
              {{ error }}
            </v-col>
            <v-col class="shrink">
              <v-btn text icon @click="error = ''">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-tabs v-model="tab" background-color="grey lighten-2">
          <v-tab key="home">Dados do Produto</v-tab>
          <v-tab key="color" :disabled="product.id === ''"
            >Material / Cor</v-tab
          >
          <v-tab key="techs" :disabled="product.id === ''">Tecnologias</v-tab>
          <v-tab key="ean" :disabled="product.id === ''">EAN</v-tab>
          <v-tab key="collections" :disabled="product.id === ''"
            >Coleções</v-tab
          >
          <v-tab key="prices" :disabled="product.id === ''"
            >Histórico de Preço</v-tab
          >
        </v-tabs>
        <v-container fluid>
          <v-tabs-items v-model="tab">
            <v-tab-item key="home" class="mt-4">
              <v-row>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="code"
                    class="
                      text-field-uppercase
                      font-weight-black
                      black-text-disabled
                    "
                    label="Referência"
                    disabled
                    hide-details
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :loading="loadingCompany"
                    :items="companies"
                    :item-text="(item) => `${item.code} - ${item.description}`"
                    item-value="id"
                    v-model="product.company_id"
                    label="Fornecedor"
                    @change="changeProvider"
                    required
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="product.reference"
                    class="text-field-uppercase"
                    label="Código do Produto"
                    dense
                    outlined
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-text-field
                    v-model="product.name"
                    class="text-field-uppercase"
                    label="Nome"
                    dense
                    outlined
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <label
                    style="
                      font-size: 12px;
                      font-weight: normal;
                      position: absolute;
                      top: 10px;
                    "
                    >Data Cadastro</label
                  >
                  <br />
                  <span
                    style="
                      font-size: 15px;
                      font-weight: bold;
                      position: absolute;
                      top: 32px;
                    "
                    >{{ product.created_at | datetimeFormatBr }}</span
                  >
                </v-col>
                <!-- <v-col cols="12" xs="12" md="2">
                  <v-chip class="ma-2" label color="green" text-color="white">
                    <v-icon left> mdi-label </v-icon>
                    {{ getLabelReissue() }}
                  </v-chip>
                </v-col> -->
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :loading="loadingProductType"
                    :items="productTypes"
                    item-text="name"
                    item-value="id"
                    v-model="product.product_type_id"
                    label="Tipo Produto"
                    required
                    dense
                    outlined
                    :rules="[rules.required]"
                    @change="changeProductType()"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :loading="loadingUnit"
                    :items="units"
                    item-text="name"
                    item-value="id"
                    v-model="product.unit_id"
                    label="Unidade"
                    required
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :loading="loadingGrid"
                    :items="grids"
                    :item-text="
                      (item) =>
                        `${item.id} - ${item.sizes
                          .map((size) => size.size)
                          .join(' ')}`
                    "
                    item-value="id"
                    v-model="product.grid_id"
                    label="Grade"
                    required
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :loading="loadingCategory"
                    :items="categories"
                    item-text="name"
                    item-value="id"
                    v-model="product.category_id"
                    label="Categoria"
                    @change="changeCategory()"
                    required
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :loading="loadingSubcategory"
                    :items="subcategories"
                    item-text="name"
                    item-value="id"
                    v-model="product.subcategory_id"
                    label="Subcategoria"
                    required
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <!-- <v-col cols="12" xs="12" md="3">
                  <v-text-field
                    v-model="product.description"
                    class="text-field-uppercase"
                    label="Descrição"
                    dense
                    outlined
                  ></v-text-field>
                </v-col> -->
                <v-col cols="12" xs="12" md="3">
                  <v-text-field
                    v-model="product.observation"
                    class="text-field-uppercase"
                    label="Observação"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-text-field
                    v-model="product.reason_disable"
                    class="text-field-uppercase"
                    label="Motivo Bloqueio"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :items="taxCodes"
                    v-model="product.tributary"
                    label="Tributação"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Preços/Coleção</label>
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="product.price_cif"
                    v-mask="'money'"
                    class="text-field-uppercase"
                    label="Preço Rede"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="product.price_fob"
                    class="text-field-uppercase"
                    label="Preço FOB"
                    dense
                    outlined
                  ></v-text-field>
                </v-col> -->
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="product.price_mult"
                    v-mask="'money'"
                    class="text-field-uppercase"
                    label="Preço Multimarcas"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2"></v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :loading="loadingCollection"
                    :items="collections"
                    item-text="name"
                    item-value="id"
                    v-model="collection_id"
                    label="Coleção"
                    required
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :items="optionsVisible"
                    v-model="product.visible_product"
                    label="Planejamento ou Pedido Express?"
                    required
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Tributos</label>
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="product.ncm"
                    class="text-field-uppercase"
                    label="Código NCM"
                    v-mask="'9999.99.99'"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="product.cest"
                    class="text-field-uppercase"
                    label="Código CEST"
                    v-mask="'99.999.99'"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-select
                    :items="cstOrigin"
                    v-model="product.cst_orig"
                    label="CST Origem"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-select
                    :items="cstTax"
                    v-model="product.cst_trib"
                    label="CST Tributação"
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Ficha Técnica</label>
                  <v-divider></v-divider>
                </v-col>
                <v-col
                  v-for="(item, idx) in extraFields"
                  :key="item.id"
                  cols="12"
                  xs="12"
                  md="2"
                >
                  <v-select
                    v-if="item.type == 'selection'"
                    v-model="extraFieldsValues[idx].value"
                    :items="item.values"
                    :label="item.name"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                  ></v-select>
                  <v-text-field
                    v-if="item.type == 'text'"
                    v-model="extraFieldsValues[idx].value"
                    class="text-field-uppercase"
                    :label="item.name"
                    dense
                    outlined
                  ></v-text-field>
                  <v-select
                    v-if="item.type == 'table' && item.values.table == 'soles'"
                    :loading="loadingSoles"
                    v-model="extraFieldsValues[idx].value"
                    :items="soles"
                    :label="item.name"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                  ></v-select>
                  <v-text-field
                    v-if="item.type == 'table' && item.values.table == 'grids'"
                    class="text-field-uppercase"
                    :label="item.name"
                    readonly
                    :value="numOfGrid"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-switch
                    v-model="product.status"
                    :label="`Status: ${getLabelStatus(product.status)}`"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn
                    color="blue darken-3"
                    dark
                    class="mt-5"
                    @click="validate"
                  >
                    <v-icon left>mdi-send</v-icon> Salvar
                  </v-btn>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item key="color" class="mt-4">
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Referência / Material / Cor</label>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="3">
                  <v-autocomplete
                    :loading="loadingMaterial"
                    :items="materials"
                    :item-text="(item) => `${item.code} - ${item.name}`"
                    item-value="id"
                    v-model="attribute.material"
                    label="Material"
                    dense
                    outlined
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-autocomplete
                    :loading="loadingColor"
                    :items="colors"
                    :item-text="(item) => `${item.code} - ${item.name}`"
                    item-value="id"
                    v-model="attribute.color"
                    label="Cor"
                    dense
                    outlined
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col cols="12" xs="12" md="2">
                  <v-text-field
                    v-model="attribute.price"
                    class="text-field-uppercase"
                    label="Preço"
                    dense
                    outlined
                  ></v-text-field>
                </v-col> -->
                <v-col cols="12" xs="12" md="2">
                  <v-file-input
                    label="Foto"
                    outlined
                    dense
                    required
                    ref="fileupload"
                    :error-messages="errorPhotoMessage"
                    @change="onFilePicked"
                    accept="image/*"
                    prepend-icon="mdi-camera"
                  ></v-file-input>
                </v-col>
                <v-col cols="12" xs="12" md="2">
                  <v-btn
                    :loading="loadingMaterialColor"
                    :disabled="loadingMaterialColor"
                    color="info"
                    @click="handleSaveMaterialColor"
                  >
                    Salvar
                    <template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>mdi-cached</v-icon>
                      </span>
                    </template>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-data-table
                    :headers="headers"
                    :loading="loadingTableMaterialColor"
                    :items="attributes"
                    sort-by="material.name"
                    class="elevation-1"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>PRODUTOS</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialogDelete" max-width="500px">
                          <v-card>
                            <v-toolbar
                              color="red lighten-1"
                              dark
                              class="text-h5"
                              >Atenção</v-toolbar
                            >
                            <v-card-title class="text-h6">
                              Tem certeza que deseja Desabilitar?
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="closeDelete"
                                >Fechar</v-btn
                              >
                              <v-btn
                                color="red darken-1"
                                dark
                                @click="deleteItemConfirm"
                              >
                                <v-icon dark>mdi-delete</v-icon>
                                Desabilitar
                              </v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialogEditPhoto" max-width="600px">
                          <v-card>
                            <v-toolbar
                              color="blue lighten-1"
                              dark
                              class="text-h5"
                              >Alterar Foto</v-toolbar
                            >
                            <v-card-text>
                              <v-row class="mt-4">
                                <v-col>
                                  <label>Material: </label>
                                  <b>{{ editPhotoAttribute.material.name }}</b>
                                </v-col>
                                <v-col>
                                  <label>Cor: </label>
                                  <b>{{ editPhotoAttribute.color.name }}</b>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <v-file-input
                                    label="Foto"
                                    outlined
                                    dense
                                    required
                                    ref="fileuploaddialog"
                                    :error-messages="errorPhotoDialogMessage"
                                    @change="onFilePickedDialog"
                                    accept="image/*"
                                    prepend-icon="mdi-camera"
                                  ></v-file-input>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="closeDialogPhoto()"
                                >Fechar</v-btn
                              >
                              <v-btn
                                color="green darken-1"
                                dark
                                @click="confirmDialogPhoto()"
                              >
                                <v-icon dark>mdi-check</v-icon>
                                Confirmar
                              </v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.material.name="{ item }">
                      <div v-if="item.status === 1">
                        {{ item.material.code }} - {{ item.material.name }}
                      </div>
                      <div
                        v-if="item.status === 0"
                        class="text-decoration-line-through"
                      >
                        {{ item.material.code }} - {{ item.material.name }}
                      </div>
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.color.name="{ item }">
                      <div v-if="item.status === 1">
                        {{ item.color.code }} - {{ item.color.name }}
                      </div>
                      <div
                        v-if="item.status === 0"
                        class="text-decoration-line-through"
                      >
                        {{ item.color.code }} - {{ item.color.name }}
                      </div>
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.photo="{ item }">
                      <v-img
                        v-if="item.status === 1"
                        :lazy-src="getUrlPhoto(item.photo)"
                        max-height="64"
                        max-width="85"
                        class="mb-2 mt-2"
                        style="cursor: zoom-in"
                        :src="getUrlPhoto(item.photo)"
                      ></v-img>
                      <div v-if="item.status === 0">Desabilitado</div>
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip
                        top
                        color="blue darken-1"
                        v-if="item.status === 1"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            class="mr-2"
                            color="blue darken-1"
                            @click="editPhoto(item)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-file-replace-outline
                          </v-icon>
                        </template>
                        <span>Trocar Foto</span>
                      </v-tooltip>
                      <v-tooltip
                        top
                        color="red darken-1"
                        v-if="item.status === 1"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="red darken-1"
                            v-bind="attrs"
                            v-on="on"
                            @click="deleteItem(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Desabilitar</span>
                      </v-tooltip>
                      <v-tooltip
                        top
                        color="gray darken-1"
                        v-if="item.status == 0"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            color="gray darken-1"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-tag-off-outline
                          </v-icon>
                        </template>
                        <span>Desabilitado</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item key="techs" class="mt-4">
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Tecnologias</label>
                  <v-divider></v-divider>
                  <v-alert type="success" v-if="successSaveTechnology">
                    <template v-slot:close>
                      <v-icon @click="() => (successSaveTechnology = false)">
                        mdi-close
                      </v-icon>
                    </template>
                    Tecnologia Vinculada com Sucesso
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :items="technologies"
                    item-text="name"
                    item-value="id"
                    label="Tecnologia"
                    v-model="technologySelected"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-row>
                  <v-col>
                    <v-btn
                      color="blue darken-3"
                      dark
                      class="mt-3"
                      @click="handleSaveTechnology"
                    >
                      Adicionar Tecnologia
                    </v-btn>
                  </v-col>
                </v-row>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-data-table
                    :headers="headersTechnology"
                    :loading="loadingTechnology"
                    :items="productTechnologies"
                    sort-by="id"
                    class="elevation-1"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>TECNOLOGIAS</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-dialog
                          v-model="dialogDeleteTechnology"
                          max-width="500px"
                        >
                          <v-card>
                            <v-toolbar
                              color="red lighten-1"
                              dark
                              class="text-h5"
                              >Atenção</v-toolbar
                            >
                            <v-card-title class="text-h6">
                              Tem certeza que deseja Deletar?
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="closeDeleteTechnology"
                                >Fechar</v-btn
                              >
                              <v-btn
                                color="red darken-1"
                                dark
                                @click="deleteItemConfirmTechnology"
                              >
                                <v-icon dark>mdi-delete</v-icon>
                                Deletar
                              </v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.technology.icon="{ item }">
                      <v-img
                        :lazy-src="getUrlPhotoTechnology(item.technology.icon)"
                        max-height="50"
                        max-width="50"
                        :src="getUrlPhotoTechnology(item.technology.icon)"
                      ></v-img>
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        color="red darken-1"
                        @click="deleteItemTechnology(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <template v-slot:no-data>
                      Esse produto não tem tecnologias vinculadas
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item key="ean" class="mt-4">
              <v-row>
                <v-col cols="12">
                  <label class="text-h6"
                    >Relacionamento de Código de Barras</label
                  >
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12">
                  <v-alert type="success" v-if="successSaveEan">
                    <template v-slot:close>
                      <v-icon @click="() => (successSaveEan = false)">
                        mdi-close
                      </v-icon>
                    </template>
                    Ean Salvo com Sucesso
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :items="materialsAttr"
                    @change="changeMaterial"
                    :item-text="(item) => `${item.code} - ${item.name}`"
                    item-value="id"
                    label="Material"
                    v-model="materialAttrSelected"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-select
                    :items="collorsAttr"
                    @change="changeColor"
                    :item-text="(item) => `${item.code} - ${item.name}`"
                    item-value="id"
                    v-model="colorAttrSelected"
                    label="Cor"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-row>
                  <v-col>
                    <v-btn
                      color="blue darken-3"
                      dark
                      class="mt-3"
                      @click="handleSaveEAN"
                    >
                      Salvar EAN
                    </v-btn>
                  </v-col>
                </v-row>
              </v-row>
              <v-row>
                <v-progress-linear
                  v-if="loadingTableEan"
                  indeterminate
                ></v-progress-linear>
                <v-simple-table dense fixed-header>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Tamanho</th>
                        <th class="text-left">EAN</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in sizesEan" :key="item.size">
                        <td>{{ item.size }}</td>
                        <td>
                          <v-text-field
                            v-model="item.ean"
                            class="text-field-uppercase pt-2 pb-0 mb-0"
                            dense
                            outlined
                          ></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-row>
            </v-tab-item>
            <v-tab-item key="collections" class="mt-4">
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Coleções</label>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-simple-table fixed-header height="300px">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Coleção</th>
                          <th class="text-left">Data Alteração</th>
                          <th class="text-left">Atual</th>
                          <th class="text-left">Usuário</th>
                          <th class="text-right">Remover</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in collectionProducts" :key="item.id">
                          <td>{{ item.collection.name }}</td>
                          <td>{{ item.updated_at | datetimeFormatBr }}</td>
                          <td v-if="getLastCollection(item)">
                            <v-chip
                              color="teal"
                              class="ma-2"
                              label
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon>mdi-checkbox-marked-circle</v-icon>
                              </v-avatar>
                              Atual
                            </v-chip>
                          </td>
                          <td v-else></td>
                          <td>{{ getUserName(item) }}</td>
                          <td class="text-right">
                            <v-tooltip top color="error">
                              <!-- eslint-disable-next-line -->
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="red darken-1"
                                  @click="deleteProductCollection(item)"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>Remover</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item key="prices" class="mt-4">
              <v-row>
                <v-col cols="12">
                  <label class="text-h6">Histórico de Preço</label>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-simple-table fixed-header height="300px">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-right" width="150">
                            R$ Anterior Rede
                          </th>
                          <th class="text-right" width="180">
                            R$ Anterior Multimarcas
                          </th>
                          <th class="text-right" width="150">R$ Novo Rede</th>
                          <th class="text-right" width="150">
                            R$ Novo Multimarcas
                          </th>
                          <th class="text-right" width="200">
                            % Reajuste Rede
                          </th>
                          <th class="text-right" width="200">
                            % Reajuste Multimarcas
                          </th>
                          <th width="200" class="text-right">Data Alteração</th>
                          <th width="200" class="text-right">Usuário</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in priceHistories" :key="item.id">
                          <td class="text-right">
                            {{ parseFloat(item.price_cif).toFixed(2) }}
                          </td>
                          <td class="text-right">
                            {{ parseFloat(item.price_mult).toFixed(2) }}
                          </td>
                          <td class="text-right">
                            {{ parseFloat(item.new_price_cif).toFixed(2) }}
                          </td>
                          <td class="text-right">
                            {{ parseFloat(item.new_price_mult).toFixed(2) }}
                          </td>
                          <td class="text-right">{{ item.percent_cif }}%</td>
                          <td class="text-right">{{ item.percent_mult }}%</td>
                          <td class="text-right">
                            {{ item.created_at | datetimeFormatBr }}
                          </td>
                          <td class="text-right">{{ getUserName(item) }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-form>
    </div>
    <v-dialog v-model="dialogCreate" width="500">
      <v-card>
        <v-card-title class="text-h5 green darken-2 white--text">
          Sucesso!
        </v-card-title>

        <v-card-text class="pt-4 text-subtitle-1 black--text">
          <p>Produto cadastrado com sucesso!</p>
          <p>
            Agora para finalizar o cadastro preencha os materiais e cores do
            produto.
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogCreate = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteCollection" max-width="500px">
      <v-card>
        <v-toolbar color="red lighten-1" dark class="text-h5"
          >Atenção</v-toolbar
        >
        <v-card-title class="text-h6">
          Tem certeza que deseja Remover?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialogCollection()"
            >Fechar</v-btn
          >
          <v-btn
            color="red darken-1"
            dark
            @click="confirmDialogDeleteCollection()"
          >
            <v-icon dark>mdi-delete</v-icon>
            Remover
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loadingFull">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";

import { URL, URL_IMAGE } from "@/api/config";

import * as ProductAPI from "@/api/requests/ProductRequest";
import * as ColorAPI from "@/api/requests/ColorRequest";
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as CategoryAPI from "@/api/requests/CategoryRequest";
import * as CollectionAPI from "@/api/requests/CollectionRequest";
import * as GridAPI from "@/api/requests/GridRequest";
import * as SubcategoryAPI from "@/api/requests/SubcategoryRequest";
import * as UnitAPI from "@/api/requests/UnitRequest";
import * as MaterialAPI from "@/api/requests/MaterialRequest";
import * as ProductTechnologyAPI from "@/api/requests/ProductTechnologyRequest";

export default {
  components: {},
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    loading: false,
    loadingFull: false,
    loadingMaterialColor: false,
    loadingCollection: false,
    errorPhotoMessage: "",
    errorPhotoDialogMessage: "",
    error: "",
    tab: null,
    product: {
      id: "",
      name: "",
      reference: "",
      company_id: "",
      product_type_id: null,
      price_fob: "0,00",
      price_cif: "0,00",
      price_mult: "0,00",
      grid_id: "",
      status: 1,
      visible_product: "A",
    },
    provider_type_id: "",
    category_id: "",
    companies: [],
    units: [],
    soles: [],
    grids: [],
    productTypes: [],
    categories: [],
    subcategories: [],
    materials: [],
    colors: [],
    collorsAttr: [],
    collections: [],
    collection_id: "",
    materialsAttr: [],
    materialAttrSelected: null,
    colorAttrSelected: null,
    sizesEan: [],
    loadingTableEan: false,
    successSaveEan: false,
    successSaveTechnology: false,
    extraFields: [],
    extraFieldsValues: [],
    attribute: {
      id: null,
      material: null,
      color: null,
      price: null,
      photo: null,
    },
    attributeDefault: {
      id: null,
      material: null,
      color: null,
      price: null,
      photo: null,
    },
    technologies: [],
    headersTechnology: [
      { text: "Nome", value: "technology.name", width: 300 },
      { text: "Descrição", value: "technology.description", width: 600 },
      { text: "Icone", value: "technology.icon", width: 150 },
      { text: "Ação", value: "actions", sortable: false, width: 75 },
    ],
    productTechnologies: [],
    technologySelected: null,
    loadingTechnology: false,
    dialogDeleteTechnology: false,
    editedItemTechnology: {
      id: null,
      name: null,
    },
    defaultItemTechnology: {
      id: null,
      name: null,
    },
    valid: true,
    lazy: false,
    loadingCompany: false,
    loadingGrid: false,
    loadingCategory: false,
    loadingSubcategory: false,
    loadingProductType: false,
    loadingUnit: false,
    loadingMaterial: false,
    loadingColor: false,
    loadingSoles: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    loadingTableMaterialColor: false,
    headers: [
      { text: "Material", value: "material.name", width: 400 },
      { text: "Cor", value: "color.name", width: 400 },
      // { text: "Preço", value: "price", width: 200 },
      { text: "Foto", value: "photo", width: 100 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 150,
        align: "right",
      },
    ],
    attributes: [],
    dialogDelete: false,
    dialogEditPhoto: false,
    editPhotoAttribute: {
      material_id: "",
      color_id: "",
      id: "",
      material: {
        id: "",
        name: "",
      },
      color: {
        id: "",
        name: "",
      },
    },
    priceHistories: [],
    collectionProducts: [],
    taxCodes: [
      { value: "99", text: "99 - 00000 - FF - SUBSTITUICAO TRIBUTACIA - AS" },
      { value: "01", text: "01 - 10000 - 01 - PRODUTO 100% TRIBUTAVEL - 1800" },
      { value: "02", text: "02 - 10000 - 02 - PRODUTO 100% TRIBUTAVEL - 1800" },
    ],
    cstOrigin: [
      { value: "0", text: "0 - Nacional" },
      { value: "1", text: "1 - Estrangeira - Importação direta" },
      { value: "2", text: "2 - Estrangeira - Adquirida no mercado interno" },
      {
        value: "3",
        text: "3 - Nacional, mercadoria ou bem com conteúdo de importação superior a 40%",
      },
      {
        value: "4",
        text: "4 - Nacional, cuja produção tenha sido feita conforme os processos produtivos básicos de que tratam o Decreto-lei 288/67, e as Leis 8.248/91",
      },
      {
        value: "5",
        text: "5 - Nacional, mercadoria ou bem com conteúdo de importação inferior ou igual a 40%",
      },
      {
        value: "6",
        text: "6 - Estrangeira, Importação direta, sem similar nacional, constante em lista de Resolução CAMEX",
      },
      {
        value: "7",
        text: "7 - Estrangeira, Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução CAMEX",
      },
    ],
    cstTax: [
      { value: "0", text: "0" },
      { value: "10", text: "10" },
      { value: "20", text: "20" },
      { value: "30", text: "30" },
      { value: "40", text: "40" },
      { value: "41", text: "41" },
      { value: "50", text: "50" },
      { value: "51", text: "51" },
      { value: "60", text: "60" },
      { value: "70", text: "70" },
      { value: "90", text: "90" },
    ],
    dialogCreate: false,
    optionsVisible: [
      { value: "A", text: "Ambos" },
      { value: "P", text: "Somente Planejamento" },
      { value: "E", text: "Somente Pedido Express" },
    ],
    dialogDeleteCollection: false,
    editedCollection: {},
  }),
  watch: {
    tab: function (newTab) {
      if (newTab === 3) {
        this.materialsAttr = this.getMaterialsAttr();
      }
    },
  },
  computed: {
    code: function () {
      if (this.product.company_id != "" && this.companies.length > 0) {
        let company = this.companies.find(
          (item) => item.id == this.product.company_id
        );
        if (typeof company === "undefined") {
          return `${this.product.reference}`;
        }
        return `${company.code}${this.product.reference}`;
      } else if (typeof this.product.reference !== "undefined") {
        return `${this.product.reference}`;
      } else {
        return "";
      }
    },
    numOfGrid: function () {
      if (this.product.grid_id !== "") {
        let gridSelected = this.grids.find(
          (item) => item.id === this.product.grid_id
        );
        if (gridSelected !== undefined) {
          return `${gridSelected.sizes[0].size} até ${
            gridSelected.sizes[gridSelected.sizes.length - 1].size
          }`;
        } else {
          return "";
        }
      }
      return "";
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getProduct(this.$route.params.id);
        this.getAttributes(this.$route.params.id);
        this.getProductHasTechnologies(this.$route.params.id);
        this.getCollectionProducts(this.$route.params.id);
        this.getPriceHistories(this.$route.params.id);
      }
      this.getCompanies();
      this.getGrids();
      this.getUnits();
      this.getMaterials();
      this.getColors();
      this.getProcutTechnologies();
      this.getSoles();
      this.getProductTypes();
      this.getCollections();
    },
    async getProduct(id) {
      this.loading = true;
      try {
        // let response = await fetch(`${URL}product/${id}`);
        // this.product = await response.json();
        this.product = await ProductAPI.getById(id);
        this.extraFieldsValues = this.product.extra_fields.map((item) => ({
          id: item.technical_field_id,
          value: item.value,
        }));
      } catch (error) {
        this.product = {};
      } finally {
        this.loading = false;
      }
    },
    async getCompanies() {
      this.loadingCompany = true;
      try {
        let data = await CompanyAPI.getAll("?type=for");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
        if (this.product.id !== "") {
          this.changeProvider();
        }
      } catch (error) {
        this.companies = {};
      } finally {
        this.loadingCompany = false;
      }
    },
    async getGrids() {
      this.loadingGrid = true;
      try {
        let data = await GridAPI.getAll();
        this.grids = data.sort((a, b) => (a.id > b.id ? 1 : -1));
      } catch (error) {
        this.grids = {};
      } finally {
        this.loadingGrid = false;
      }
    },
    async getUnits() {
      this.loadingUnit = true;
      try {
        let data = await UnitAPI.getAll();
        this.units = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.units = {};
      } finally {
        this.loadingUnit = false;
      }
    },
    async getSoles() {
      this.loadingSoles = true;
      try {
        let response = await fetch(`${URL}sole`);
        let data = await response.json();
        this.soles = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        this.soles = this.soles.map((item) => ({
          ...item,
          id: `${item.id}`,
        }));
      } catch (error) {
        this.soles = {};
      } finally {
        this.loadingSoles = false;
      }
    },
    async getProductTypes() {
      this.loadingProductType = true;
      try {
        let response = await fetch(`${URL}product-types`);
        let data = await response.json();
        this.productTypes = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        if (this.product.product_type_id !== null) {
          this.changeProductType();
        }
      } catch (error) {
        this.productTypes = {};
      } finally {
        this.loadingProductType = false;
      }
    },
    async getCategories() {
      this.loadingCategory = true;
      try {
        let data = await CategoryAPI.getAll(
          `?provider_type_id=${this.provider_type_id}`
        );
        console.log(data);
        this.categories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        console.log(this.categories);
        if (this.product.id !== "") {
          this.changeCategory();
        }
      } catch (error) {
        this.categories = [];
      } finally {
        this.loadingCategory = false;
      }
    },
    async getSubcategories() {
      this.loadingSubcategory = true;
      try {
        let data = await SubcategoryAPI.getAll(
          `?category_id=${this.category_id}`
        );
        this.subcategories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.subcategories = [];
      } finally {
        this.loadingSubcategory = false;
      }
    },
    async getMaterials() {
      this.loadingMaterial = true;
      try {
        let data = await MaterialAPI.getAll();
        this.materials = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.materials = {};
      } finally {
        this.loadingMaterial = false;
      }
    },
    async getColors() {
      this.loadingColor = true;
      try {
        let data = await ColorAPI.getAll();
        this.colors = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.colors = {};
      } finally {
        this.loadingColor = false;
      }
    },
    async getCollections() {
      this.loadingCollection = true;
      try {
        let data = await CollectionAPI.getAll();
        this.collections = data;
      } catch (error) {
        this.collections = [];
      } finally {
        this.loadingCollection = false;
      }
    },
    async deleteItemConfirm() {
      this.loadingTableMaterialColor = true;
      try {
        let res = await fetch(
          `${URL}product/${this.product.id}/attribute/${this.editedItem.id}`,
          {
            method: "DELETE",
          }
        );
        if (res) {
          this.attribute = { ...this.attributeDefault };
          this.$refs.fileupload.reset();
          this.getAttributes(this.product.id);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingTableMaterialColor = false;
      }
      // this.loading = true;
      // this.products = [];
      // try {
      //   let res = await fetch(`${URL}product/${this.editedItem.id}`, {
      //     method: "DELETE",
      //   });
      //   if (res.ok) {
      //     this.loading = false;
      //     this.initialize();
      //   }
      // } catch (error) {
      //   this.loading = false;
      //   console.log(error);
      // }
      this.closeDelete();
    },
    goToBackList() {
      this.$router.push({ name: "Product" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        let keys = Object.keys(this.product);
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i];
          if (typeof this.product[key] == "string") {
            this.product[key] = this.product[key].toUpperCase();
          }
        }

        let data = Object.assign({}, this.product);

        data.status = data.status ? 1 : 0;
        // data.description = ;
        data.price_fob = 0.0;
        if (data.price_cif.includes(",")) {
          data.price_cif = parseFloat(
            data.price_cif.replace(/\./gi, "").replace(/,/gi, ".")
          );
        }
        if (data.price_mult.includes(",")) {
          data.price_mult = parseFloat(
            data.price_mult.replace(/\./gi, "").replace(/,/gi, ".")
          );
        }

        data.collection_id = this.collection_id;
        data.extraFields = this.extraFieldsValues;
        // return false;
        if (data.id === "") {
          this.post(data);
        } else {
          this.update(data.id, data);
        }
      }
    },
    async post(data) {
      this.loadingFull = true;
      try {
        let res = await ProductAPI.post(data);
        this.dialogCreate = true;
        // res = await res.json();
        this.product = res.product;
        this.tab = 1;
        history.pushState({}, null, `/produto/${this.product.id}`);
        // let myHeaders = new Headers({
        //   "Content-Type": "application/json",
        // });
        // let res = await fetch(`${URL}product`, {
        //   method: "POST",
        //   headers: myHeaders,
        //   body: JSON.stringify(data),
        // });
        // console.log(res);
        // SHOW MSG PARA PREENCHER MATERIAL E COR

        // if (res) {
        // this.goToBackList();
        // }
      } catch (error) {
        this.error = "Houve um error ao salvar, tente novamente mais tarde";
      } finally {
        this.loadingFull = false;
      }
    },
    async update(id, data) {
      this.loadingFull = true;
      try {
        await ProductAPI.update(id, data);
        this.goToBackList();

        // let myHeaders = new Headers({
        //   "Content-Type": "application/json",
        // });
        // let res = await fetch(`${URL}product/${id}`, {
        //   method: "PUT",
        //   headers: myHeaders,
        //   body: JSON.stringify(data),
        // });
        // if (res) {
        // }
      } catch (error) {
        this.error = "Houve um error ao salvar, tente novamente mais tarde";
      } finally {
        this.loadingFull = false;
      }
    },
    async getProcutTechnologies() {
      this.loadingTechnology = true;
      this.technologies = [];
      try {
        let data = await ProductTechnologyAPI.getAll();
        this.technologies = data
          .filter((item) => item.status === 1)
          .sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        // console.log(error);
      } finally {
        this.loadingTechnology = false;
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    changeProvider() {
      let old_provider_type_id = this.provider_type_id;
      let companySelected = this.companies.find(
        (item) => item.id === this.product.company_id
      );

      if (typeof companySelected !== "undefined") {
        this.provider_type_id = companySelected.provider_type_id;

        if (old_provider_type_id !== this.provider_type_id) {
          this.categories = [];
          this.subcategories = [];
          this.getCategories();
        }
      }
    },
    changeCategory() {
      let old_category_id = this.category_id;
      let categorySelected = this.categories.find(
        (item) => item.id === this.product.category_id
      );
      this.category_id = categorySelected.id;
      if (old_category_id !== this.category_id) {
        this.subcategories = [];
        this.getSubcategories();
      }
    },
    handleSaveMaterialColor() {
      this.loadingMaterialColor = true;
      if (this.attribute.material == "") {
        return false;
      }
      if (this.attribute.color == "") {
        return false;
      }

      let form = new FormData();
      form.append("product_id", this.product.id);
      form.append("material_id", this.attribute.material);
      form.append("color_id", this.attribute.color);
      form.append("price", 0.0);
      form.append("photo", this.attribute.photo);

      if (this.attribute.id === "" || this.attribute.id === null) {
        this.postAttribute(form);
      } else {
        form.append("_method", "PUT");
        this.updateAttribute(this.attribute.id, form);
      }
      this.loadingMaterialColor = false;
    },
    async getAttributes(id) {
      this.loadingTableMaterialColor = true;
      try {
        let response = await fetch(`${URL}product/${id}/attribute`);
        let data = await response.json();
        this.attributes = data;
      } catch (error) {
        this.attributes = [];
      } finally {
        this.loadingTableMaterialColor = false;
      }
    },
    async postAttribute(data) {
      this.loadingTableMaterialColor = true;
      try {
        let res = await fetch(`${URL}product/${this.product.id}/attribute`, {
          method: "POST",
          body: data,
        });
        if (res) {
          this.attribute = { ...this.attributeDefault };
          this.$refs.fileupload.reset();
          this.getAttributes(this.product.id);
        }
      } catch (error) {
        // console.log(error);
      } finally {
        this.loadingTableMaterialColor = false;
      }
    },
    async updateAttribute(id, data) {
      this.loadingTableMaterialColor = true;
      try {
        let res = await fetch(
          `${URL}product/${this.product.id}/attribute/${id}`,
          {
            method: "POST",
            body: data,
          }
        );
        if (res) {
          this.attribute = { ...this.attributeDefault };
          this.$refs.fileupload.reset();
          this.getAttributes(this.product.id);
        }
      } catch (error) {
        // console.log(error);
      } finally {
        this.loadingTableMaterialColor = false;
      }
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    editItem(item) {
      this.$router.push({
        name: "ProductEdit",
        params: { id: item.id, grid: item },
      });
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    onFilePicked(e) {
      this.attribute.photo = e;
      this.errorPhotoMessage = "";
    },
    onFilePickedDialog(e) {
      this.photoDialog = e;
      this.errorPhotoDialogMessage = "";
    },
    getUrlPhoto(photo) {
      if (photo !== "") {
        return `${URL_IMAGE}${photo}`;
      } else {
        return "";
      }
    },
    getMaterialsAttr() {
      let materialsFilter = this.attributes.filter(
        (v, i, a) => a.findIndex((t) => t.material_id === v.material_id) === i
      );
      materialsFilter = materialsFilter.map((item) => item.material);
      return materialsFilter;
    },
    changeMaterial() {
      let colorsFilter = this.attributes
        .filter((item) => item.material_id === this.materialAttrSelected)
        .filter(
          (v, i, a) => a.findIndex((t) => t.color_id === v.color_id) === i
        );
      colorsFilter = colorsFilter.map((item) => item.color);
      this.collorsAttr = colorsFilter;
      this.sizesEan = [];
      this.colorAttrSelected = null;
    },
    changeColor() {
      this.getEans(this.materialAttrSelected, this.colorAttrSelected);
    },
    async getEans(material, color) {
      this.loadingTableEan = true;
      try {
        let res = await fetch(
          `${URL}product/${this.product.id}/ean?material=${material}&color=${color}`
        );
        res = await res.json();
        if (res.length == 0) {
          let gridSelected = this.grids.find(
            (item) => item.id == this.product.grid_id
          );
          if (gridSelected !== undefined) {
            this.sizesEan = gridSelected.sizes.map((item) => ({
              id: "",
              size: item.size,
              ean: "",
            }));
          }
        } else {
          this.sizesEan = res;
        }
      } catch (error) {
        // console.log(error);
      } finally {
        this.loadingTableEan = false;
      }
    },
    handleSaveEAN() {
      this.saveEAN({
        data: this.sizesEan,
        material_id: this.materialAttrSelected,
        color_id: this.colorAttrSelected,
      });
    },
    async saveEAN(data) {
      this.loadingTableEan = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}product/${this.product.id}/ean`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        let response = await res.json();
        console.log(response);
        this.sizesEan = [];
        this.colorAttrSelected = null;
        this.materialAttrSelected = null;
        this.successSaveEan = true;
      } catch (error) {
        // this.error = "Houve um error ao salvar, tente novamente mais tarde";
      } finally {
        this.loadingTableEan = false;
      }
    },
    handleSaveTechnology() {
      this.saveProductHasTechnology(this.product.id, this.technologySelected);
    },
    async saveProductHasTechnology(product_id, technology_id) {
      console.log(product_id);
      let data = { product_technology_id: technology_id };
      this.loadingTableTechnology = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}product/${product_id}/technology`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        let response = await res.json();
        console.log(response);
        this.getProductHasTechnologies(product_id);
        this.technologySelected = null;
        this.successSaveTechnology = true;
      } catch (error) {
        // this.error = "Houve um error ao salvar, tente novamente mais tarde";
      } finally {
        this.loadingTableTechnology = false;
      }
    },
    closeDeleteTechnology() {
      this.dialogDeleteTechnology = false;
      this.$nextTick(() => {
        this.editedItemTechnology = Object.assign(
          {},
          this.defaultItemTechnology
        );
      });
    },
    async deleteItemConfirmTechnology() {
      this.loadingTechnology = true;
      try {
        let res = await fetch(
          `${URL}product/${this.product.id}/technology/${this.editedItemTechnology.id}`,
          {
            method: "DELETE",
          }
        );
        if (res.ok) {
          this.loadingTechnology = false;
          this.getProductHasTechnologies(this.product.id);
        }
      } catch (error) {
        this.loadingTechnology = false;
      }
      this.closeDeleteTechnology();
    },
    async getProductHasTechnologies(id) {
      this.loadingTechnology = true;
      this.productTechnologies = [];
      try {
        let response = await fetch(`${URL}product/${id}/technology`);
        let data = await response.json();
        this.productTechnologies = data;
        console.log(this.technologies);
        console.log(this.productTechnologies);
        this.technologies = this.technologies.filter(
          (item) =>
            this.productTechnologies.find(
              (y) => y.product_technology_id === item.id
            ) === undefined
        );
        console.log(this.technologies);
      } catch (error) {
        this.productTechnologies = [];
      } finally {
        this.loadingTechnology = false;
      }
    },
    getUrlPhotoTechnology(icon) {
      if (icon !== "") {
        return `${URL_IMAGE}${icon}`;
      } else {
        return "";
      }
    },
    deleteItemTechnology(item) {
      this.editedItemTechnology = Object.assign({}, item);
      this.dialogDeleteTechnology = true;
    },
    async getPriceHistories(id) {
      try {
        let res = await fetch(`${URL}price-history?product=${id}`);
        res = await res.json();
        this.priceHistories = res;
      } catch (error) {
        console.log(error);
      }
    },
    getLastCollection(item) {
      console.log(item);
      return item.id === this.collectionProducts[0].id;
    },
    async getCollectionProducts(id) {
      try {
        let res = await fetch(`${URL}collection-product?product=${id}`);
        res = await res.json();
        this.collectionProducts = res;
        if (this.collectionProducts.length > 0) {
          this.collection_id = this.collectionProducts[0].collection_id;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getLabelReissue() {
      return this.collectionProducts.length <= 1
        ? "Produto Lançamento"
        : "Produto Reedição";
    },
    changeProductType() {
      const type = this.productTypes.find(
        (item) => item.id === this.product.product_type_id
      );
      const fields = type.fields;
      this.extraFields = fields;
      if (this.extraFieldsValues.length === 0) {
        this.extraFieldsValues = this.extraFields.map((item) => ({
          id: item.id,
          value: "",
        }));
      }
    },
    getUserName(item) {
      if (item.user !== null) {
        return item.user.name;
      } else {
        return "";
      }
    },
    editPhoto(item) {
      this.editPhotoAttribute = Object.assign({}, item);
      this.dialogEditPhoto = true;
    },
    closeDialogPhoto() {
      this.editPhotoAttribute = Object.assign(
        {},
        {
          id: "",
          material_id: "",
          color_id: "",
          material: { id: "", name: "" },
          color: { id: "", name: "" },
        }
      );
      this.dialogEditPhoto = false;
    },
    async confirmDialogPhoto() {
      let form = new FormData();
      form.append("product_id", this.product.id);
      form.append("material_id", this.editPhotoAttribute.material_id);
      form.append("color_id", this.editPhotoAttribute.color_id);
      form.append("price", 0.0);
      form.append("photo", this.photoDialog);
      form.append("_method", "PUT");

      this.dialogEditPhoto = false;

      this.loadingTableMaterialColor = true;
      try {
        let res = await fetch(
          `${URL}product/${this.product.id}/attribute/${this.editPhotoAttribute.id}`,
          {
            method: "POST",
            body: form,
          }
        );
        if (res) {
          console.log(res.json);
          this.editPhotoAttribute = Object.assign(
            {},
            {
              id: "",
              material_id: "",
              color_id: "",
              material: { id: "", name: "" },
              color: { id: "", name: "" },
            }
          );
          this.$refs.fileuploaddialog.reset();
          this.getAttributes(this.product.id);
        }
      } catch (error) {
        // console.log(error);
      } finally {
        this.loadingTableMaterialColor = false;
      }
    },
    deleteProductCollection(item) {
      this.editedCollection = item;
      this.dialogDeleteCollection = true;
    },
    closeDialogCollection() {
      this.dialogDeleteCollection = false;
      this.$nextTick(() => {
        this.editedCollection = Object.assign({}, {});
      });
    },
    async confirmDialogDeleteCollection() {
      console.log(this.editedCollection);
      this.dialogDeleteCollection = false;
      // this.loading = true;
      // this.cests = [];
      try {
        //   await API.destroy(this.editedItem.id);
        //   this.loading = false;
        //   this.initialize();
        let res = await fetch(
          `${URL}collection-product/${this.editedCollection.id}`,
          { method: "DELETE" }
        );
        res = await res.json();
        console.log(res);
        this.getCollectionProducts(this.product.id);
      } catch (error) {
        //   this.loading = false;
        //   console.log(error);
      }
      // this.closeDelete();
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}

.black-text-disabled input[disabled] {
  color: #000 !important;
}

.black-text-disabled label.v-label--is-disabled {
  color: #333 !important;
  font-weight: 400;
}
</style>
